import { denormalisedResponseEntities } from '../../util/data';
import { addOwnEntities } from '../../containers/ManageListingsPage/ManageListingsPage.duck';

export const REVIEW_INTERVAL = 30 * 24 * 60 * 60 * 1000;

export const needsAvailabilityReview = (listing, now = Date.now()) => {
  const { state, createdAt, privateData = {} } = listing.attributes;
  const created = new Date(createdAt).getTime();
  const confirmed = Date.parse(privateData.availabilityConfirmedAt);
  const lastReviewed = Number.isFinite(confirmed) ? Math.max(created, confirmed) : created;
  const quantity = listing.currentStock?.attributes?.quantity;
  return (
    state === 'published' &&
    Number.isFinite(quantity) &&
    quantity > 0 &&
    now - lastReviewed > REVIEW_INTERVAL
  );
};

// Query every page: a seller's older listings may be beyond the first page.
export const fetchAvailabilityReviews = () => async (dispatch, getState, sdk) => {
  const listings = [];
  let page = 1;
  let totalPages = 1;
  do {
    const response = await sdk.ownListings.query({
      page,
      perPage: 100,
      include: ['images', 'currentStock'],
      'limit.images': 1,
      'fields.image': ['variants.scaled-medium', 'variants.scaled-large'],
    });
    listings.push(
      ...denormalisedResponseEntities(response).filter(l => needsAvailabilityReview(l))
    );
    totalPages = response.data.meta.totalPages;
    page += 1;
  } while (page <= totalPages);
  return listings;
};

export const reviewAvailability = (listingId, keepSelling) => async (dispatch, getState, sdk) => {
  const userId = getState().user.currentUser?.id?.uuid;
  // Recheck in case the listing was closed, confirmed, or sold while the popup was open.
  const current = await sdk.ownListings.show({ id: listingId, include: ['currentStock'] });
  const [listing] = denormalisedResponseEntities(current);
  const response = !needsAvailabilityReview(listing)
    ? current
    : keepSelling
    ? await sdk.ownListings.update(
        { id: listingId, privateData: { availabilityConfirmedAt: new Date().toISOString() } },
        { expand: true }
      )
    : await sdk.ownListings.close({ id: listingId }, { expand: true });
  if (getState().user.currentUser?.id?.uuid === userId) {
    dispatch(addOwnEntities(response));
  }
  return response;
};
